// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1SaCL","buttonInspector":"style_buttonInspector__uro0S","dateText":"style_dateText__3wSUD","broadcastName":"style_broadcastName__1pHLE"};